import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'landing',
    component: () => import(/* webpackChunkName: "landing" */ '../views/Landing/Index.vue')
  },
  {
    path: '/web',
    name: 'web',
    component: () => import(/* webpackChunkName: "project-preview" */ '../views/Preview/Index.vue')
  },
  {
    path: '/promo',
    name: 'promo',
    component: () => import(/* webpackChunkName: "promo" */ '../views/Promo/Index.vue')
  },
  {
    path: '/protocol/:type?',
    name: 'protocol',
    component: () => import(/* webpackChunkName: "protocol" */ '../views/Protocol/Index.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
